import { useSyncExternalStore } from 'react'

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange)
  window.addEventListener('offline', onChange)
  return () => {
    window.removeEventListener('online', onChange)
    window.removeEventListener('offline', onChange)
  }
}

/** Browser connectivity only — Firestore keeps working either way. */
export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.navigator.onLine,
    () => true,
  )
}
